import { resource, RequestConfig } from '../helper/resource';

/**
 * 备用方案-simu是否启用备用方案true启用false禁用
 */
export function zgServer_cardSwitchPfUsingPOST(req: void, config?: RequestConfig): Promise<ZgServer.ApiResultboolean> {
  return resource.post('/pf/client/cardSwitch', req, config);
}

/**
 * 个人购买私募权限校验
 */
export function zgServer_checkPersonPermissionUsingPOST(
  req: ZgServer.Production | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/pf/client/permission', req, config);
}

/**
 * 是否合格私募投资者-权限及是否过期
 */
export function zgServer_isVerifiedPfUsingPOST(req: void, config?: RequestConfig): Promise<ZgServer.ApiResultstring> {
  return resource.post('/pf/client/verified', req, config);
}

/**
 * 个人购买私募-客户是否需要双录
 */
export function zgServer_doubleRecordingPfUsingPOST(
  req: ZgServer.ClientRecord | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultboolean> {
  return resource.post('/pf/clientNew/doubleRecording', req, config);
}

/**
 * 私募查询风险揭示书代销机构版
 */
export function zgServer_getRiskDXUsingPOST(
  req: ZgServer.PfDxParam | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultZgClientContract> {
  return resource.post('/pf/contract/getRiskDX', req, config);
}

/**
 * 查询风险揭示书代销机构版签署状态
 */
export function zgServer_getRiskDXSignUsingPOST(
  req: ZgServer.DxSignId | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultZgClientContract> {
  return resource.post('/pf/contract/getRiskDXSign', req, config);
}

/**
 * 柜台331150查询客户信息
 */
export function zgServer_getClientInfoHsUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultMapstringstring> {
  return resource.post('/pf/getClientInfoHs', req, config);
}

/**
 * [No Auth]查询本地是否签署过协议
 */
export function zgServer_getLocalFilesUsingPOST(
  req: ZgServer.PfSignContractParam,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListLcPfLeaveMarks> {
  return resource.postNoAuth('/pf/getLocalFiles', req, config);
}

/**
 * [No Auth]认申购回访截止时间查询
 */
export function zgServer_getRevisitEndTimeUsingPOST(
  req: ZgServer.RevisitEndDto | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.postNoAuth('/pf/getRevisitEndTime', req, config);
}

/**
 * [No Auth]调CRM查客户的投资经理姓名
 */
export function zgServer_getRltEmpByCrmUsingPOST(
  req: ZgServer.ClientIdParam | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultZgRltInfo> {
  return resource.postNoAuth('/pf/getRltEmpByCrm', req, config);
}

/**
 * [No Auth]查妥妥递appid
 */
export function zgServer_getTtdAppIdUsingPOST(req: void, config?: RequestConfig): Promise<ZgServer.ApiResultstring> {
  return resource.postNoAuth('/pf/getTtdAppId', req, config);
}

/**
 * [No Auth]私募签署协议留痕
 */
export function zgServer_leavePfFilesUsingPOST(
  req: ZgServer.PfSignContractParam,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.postNoAuth('/pf/leavePfFiles', req, config);
}

/**
 * [No Auth]查询客户是否需要创建订单
 */
export function zgServer_needCreateOrderUsingPOST(
  req: ZgServer.PfClientOrderDto | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.postNoAuth('/pf/needCreateOrder', req, config);
}

/**
 * [No Auth]私募协议阅读留痕
 */
export function zgServer_pfReadSignUsingPOST(
  req: ZgServer.ReadLeave | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.postNoAuth('/pf/pfReadSign', req, config);
}

/**
 * [No Auth]备用方案-simu自研切换
 */
export function zgServer_processSwitchPfUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.postNoAuth('/pf/process/switch', req, config);
}

/**
 * [No Auth]客户下单后订单号初始化状态
 */
export function zgServer_saveOrderStatusUsingPOST(
  req: ZgServer.PfClientOrderDto | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.postNoAuth('/pf/saveOrderStatus', req, config);
}

/**
 * [No Auth]客户下单后订单号更新状态
 */
export function zgServer_updateOrderStatusUsingPOST(
  req: ZgServer.PfClientOrderDto | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.postNoAuth('/pf/updateOrderStatus', req, config);
}

/**
 * [No Auth]私募签署协议留痕中证
 */
export function zgServer_zzLeavePfFilesUsingPOST(
  req: ZgServer.PfSignContractParam,
  config?: RequestConfig
): Promise<void> {
  return resource.postNoAuth('/pf/zzLeavePfFiles', req, config);
}

/**
 * [No Auth]私募是否中证签署过
 */
export function zgServer_zzSignLeaveUsingPOST(
  req: ZgServer.ClientAndProdParam | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultint> {
  return resource.postNoAuth('/pf/zzSignLeave', req, config);
}
